import {
	showcaseReportFull,
	showcaseReportStudio,
	showcaseReportStudios,
	showcaseReportSend,
	showcaseKeys,
	showcaseCreateKeyCampaign,
	showcaseAddKeys,
	showcaseKeyRedemptions,
} from '@/services/agency/showcaseReport.service'

export default {
	namespaced: true,
	state: {
		report: null,
		studioReport: null,
		studios: [],
		keyCampaigns: [],
		keyRedemptions: null,
		reportStatus: 'init',
		studioReportStatus: 'init',
		sendStatus: 'init',
		keysStatus: 'init',
	},
	getters: {
		getReport(state) {
			return state.report
		},
		getStudioReport(state) {
			return state.studioReport
		},
		getStudios(state) {
			return state.studios
		},
		getKeyCampaigns(state) {
			return state.keyCampaigns
		},
		getKeyRedemptions(state) {
			return state.keyRedemptions
		},
		getKeysStatus(state) {
			return state.keysStatus
		},
		getReportStatus(state) {
			return state.reportStatus
		},
		getStudioReportStatus(state) {
			return state.studioReportStatus
		},
		getSendStatus(state) {
			return state.sendStatus
		},
	},
	mutations: {
		SET_REPORT(state, value) {
			state.report = value
		},
		SET_STUDIO_REPORT(state, value) {
			state.studioReport = value
		},
		SET_STUDIOS(state, value) {
			state.studios = value
		},
		SET_KEY_CAMPAIGNS(state, value) {
			state.keyCampaigns = value
		},
		SET_KEY_REDEMPTIONS(state, value) {
			state.keyRedemptions = value
		},
		KEYS_STATUS(state, value) {
			state.keysStatus = value
		},
		REPORT_STATUS(state, value) {
			state.reportStatus = value
		},
		STUDIO_REPORT_STATUS(state, value) {
			state.studioReportStatus = value
		},
		SEND_STATUS(state, value) {
			state.sendStatus = value
		},
	},
	actions: {
		async fetchReport({ commit }, showcaseId) {
			commit('REPORT_STATUS', 'pending')
			try {
				const response = await showcaseReportFull(showcaseId)
				const report = response.data?.data ?? response.data ?? null
				commit('SET_REPORT', report)
				commit('REPORT_STATUS', 'init')
				return report
			} catch (error) {
				commit('REPORT_STATUS', 'init')
				throw error
			}
		},
		async fetchStudioReport({ commit }, { showcaseId, submissionId }) {
			commit('STUDIO_REPORT_STATUS', 'pending')
			try {
				const { data } = await showcaseReportStudio(showcaseId, submissionId)
				commit('SET_STUDIO_REPORT', data.data)
				commit('STUDIO_REPORT_STATUS', 'init')
				return data
			} catch (error) {
				commit('STUDIO_REPORT_STATUS', 'init')
				throw error
			}
		},
		async fetchStudios({ commit }, showcaseId) {
			try {
				const { data } = await showcaseReportStudios(showcaseId)
				commit('SET_STUDIOS', data.data)
				return data
			} catch (error) {
				throw error
			}
		},
		async sendReport({ commit }, { showcaseId, params }) {
			commit('SEND_STATUS', 'pending')
			try {
				const { data } = await showcaseReportSend(showcaseId, params)
				commit('SEND_STATUS', 'init')
				return data
			} catch (error) {
				commit('SEND_STATUS', 'init')
				throw error
			}
		},
		async fetchKeyCampaigns({ commit }, showcaseId) {
			commit('KEYS_STATUS', 'pending')
			try {
				const { data } = await showcaseKeys(showcaseId)
				commit('SET_KEY_CAMPAIGNS', data.data)
				commit('KEYS_STATUS', 'init')
				return data
			} catch (error) {
				commit('KEYS_STATUS', 'init')
				throw error
			}
		},
		async createKeyCampaign({ commit }, { showcaseId, params }) {
			commit('KEYS_STATUS', 'pending')
			try {
				const { data } = await showcaseCreateKeyCampaign(showcaseId, params)
				commit('KEYS_STATUS', 'init')
				return data
			} catch (error) {
				commit('KEYS_STATUS', 'init')
				throw error
			}
		},
		async addKeyCodes({ commit }, { showcaseId, keyId, params }) {
			try {
				const { data } = await showcaseAddKeys(showcaseId, keyId, params)
				return data
			} catch (error) {
				throw error
			}
		},
		async fetchKeyRedemptions({ commit }, { showcaseId, keyId }) {
			try {
				const { data } = await showcaseKeyRedemptions(showcaseId, keyId)
				commit('SET_KEY_REDEMPTIONS', data.data)
				return data
			} catch (error) {
				throw error
			}
		},
	},
}
